import SimpleTwoButtonPopup from '@sophocles/components/SimpleTwoButtonPopup/SimpleTwoButtonPopup';

export default SimpleTwoButtonPopup;
